module.exports = __webpack_public_path__ + "img/contact_2.a185aec3.png";